import { api } from '@/lib/api/client';
import { unwrap } from '@/lib/api/envelope';
import { Endpoints } from '@/lib/api/endpoints';
import type { ResponseEnvelope } from '@/types/api';

export interface SecurityStatus {
  keycloakEnabled: boolean;
  keycloakIssuerUri: string;
  apiKeyAuthEnabled: boolean;
  hmacSignatureEnabled: boolean;
  environment: string;
  securityWarning: string | null;
}

export async function fetchSecurityStatus(): Promise<SecurityStatus> {
  const res = await api.get<ResponseEnvelope<SecurityStatus>>(
    Endpoints.dashboard.securityStatus,
  );
  return unwrap(res);
}
